import { startOfDay } from 'date-fns';
export const getInitialCalendarDate = ({ selectedDate, minDate, maxDate, }) => {
    if (selectedDate)
        return selectedDate;
    const today = startOfDay(new Date());
    const isTodayAfterMin = minDate ? today >= startOfDay(minDate) : true;
    const isTodayBeforeMax = maxDate ? today <= startOfDay(maxDate) : true;
    const isTodayInRange = isTodayAfterMin && isTodayBeforeMax;
    if (isTodayInRange)
        return today;
    const fallbackDate = minDate ?? maxDate ?? today;
    return fallbackDate;
};
